import { Toast } from 'vant-ui';
import axios from "#/net/axios";

async function fetchGeoFencer(shopId)
{
    let customerGeoFencer = null;
    let deliveryGeoFencer = null;
    //
    axios.shop.get("supplierInfo/getGeofencePath.do", {
        shopId: 70,
    })
    .then(({ statusCode, msg, data }) => {
        if (parseInt(statusCode) !== 200) {
            return Toast(`获取物流地理围栏失败, ${msg}`)
        }

        //
        if (data.geofencePath && data.geofencePath.length > 0) {
            deliveryGeoFencer = data.geofencePath.map(el => {
                return [el.lon, el.lat]
            });
            deliveryGeoFencer.push(deliveryGeoFencer[0])
        }
    })
    .catch((e) => {
        Toast(`获取物流地理围栏失败, ${e.toString()}`)
    }).finally(() => {
        if (deliveryGeoFencer == null) {
            deliveryGeoFencer = [];
        }
    })

    //
    axios.shop.get("supplierInfo/getGeofencePath.do", {
        shopId: shopId,
    })
    .then(({ statusCode, msg, data }) => {
        if (parseInt(statusCode) !== 200) {
            return Toast(`获取店铺自定义地理围栏失败, ${msg}`)
        }

        //
        if (data.geofencePath && data.geofencePath.length > 0)
        {
            customerGeoFencer = data.geofencePath.map(el => {
                return [el.lon, el.lat]
            });
            customerGeoFencer.push(customerGeoFencer[0]);
        }
    })
    .catch((e) => {
        Toast(`获取店铺自定义地理围栏失败, ${e.toString()}`)
    }).finally(() => {
        if (customerGeoFencer == null) {
            customerGeoFencer = [];
        }
    })

    /**
     * 
     */
    //
    while (true) {
        if (deliveryGeoFencer != null &&
            customerGeoFencer != null) {
            break;
        }

        await new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 1000);
        })
    }

    //
    const innerList = [];
    if(false)
    {
        if (deliveryGeoFencer.length > 0 && customerGeoFencer.length > 0) {
            const poly1 = turf.polygon([deliveryGeoFencer]);
            const poly2 = turf.polygon([customerGeoFencer]);
            for (let coordinate of turf.union(poly1, poly2).geometry.coordinates) {
                const inner = []
                coordinate.forEach(el => {
                    inner.push([el[0], el[1]])
                });
                innerList.push(inner);
            }
        }
    }
    
    if (customerGeoFencer.length > 0) {
        innerList.push(customerGeoFencer);
    }
    else {
        innerList.push(deliveryGeoFencer);
    }
    

    //
    return innerList;
}

export {
    fetchGeoFencer,
}